export default "__VITE_ASSET__DAVPeZEq__";